import React from 'react';
import { AttendanceTrackingPageHeader } from 'components/molecules/AttendanceTrackingPageHeader';
import { AttendanceSettingsForm } from 'components/organisms/AttendanceSettingsForm';
import './index.scss';

export const AttendanceTrackingSettings = () => {
  return (
    <div className="attendance-tracking-settings-page">
      <AttendanceTrackingPageHeader
        title="Settings"
        description="Configure office-day thresholds and assign users who can upload attendance sheets."
        crumbs={[{ label: 'Attendance Tracking' }, { label: 'Settings' }]}
      />
      <AttendanceSettingsForm />
    </div>
  );
};
